// @flow

import i18n from "../../../i18n";

export const isEmail = (value?: ?string) => {
  return typeof value !== "string" || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? undefined
    : i18n.t("validation:isEmail");
};
